<template>
  <b-modal
    v-model="localValue"
    title="Cách tính chỉ số"
    size="xl"
    hide-footer
    scrollable
  >
    <b-table
      :items="formulaItems"
      :fields="formulaFields"
      bordered
      small
      hover
      class="formula-table"
    >
      <template v-slot:cell(stt)="row">
        <div class="text-center font-weight-bold">{{ row.item.stt }}</div>
      </template>
      <template v-slot:cell(formula)="row">
        <code class="formula-code">{{ row.item.formula }}</code>
      </template>
    </b-table>
  </b-modal>
</template>

<script>
export default {
  name: 'FormulaExplanationModal',
  model: {
    prop: 'value',
    event: 'input',
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    localValue: {
      get() {
        return this.value
      },
      set(next) {
        this.$emit('input', next)
      },
    },
  },
  data() {
    return {
      formulaFields: [
        { key: 'stt', label: 'STT', thStyle: { width: '60px', textAlign: 'center' } },
        { key: 'term', label: 'Thuật ngữ', thStyle: { width: '180px', fontWeight: 600 } },
        { key: 'meaning', label: 'Ý nghĩa', thStyle: { fontWeight: 600 } },
        { key: 'formula', label: 'Công thức tính', thStyle: { width: '320px', fontWeight: 600 } },
      ],
      formulaItems: [
        {
          stt: '(1.1)',
          term: 'Tiền hàng thực bán',
          meaning:
            'Tổng giá trước thuế (chưa trừ chiết khấu) của tất cả sản phẩm trong đơn. Được tính bằng cách bóc tách phần thuế VAT ra khỏi giá bán.',
          formula: 'Tiền hàng thực bán = Σ (Giá vốn trước thuế × Số lượng)',
        },
        {
          stt: '(1.2)',
          term: 'Thuế VAT',
          meaning:
            'Thuế VAT thực tế phát sinh sau khi đã trừ phần thuế nằm trong chiết khấu item và chiết khấu bill. Đơn trả hàng dùng giá trị âm.',
          formula:
            'Thuế VAT = Thuế gốc - Thuế chiết khấu từng item trong bill - Thuế chiết khấu toàn bill',
        },
        {
          stt: '(1.3)',
          term: 'Phí GH (khách)',
          meaning:
            'Phí giao hàng thu của khách hàng (trực tiếp từ hóa đơn). Đơn trả hàng dùng giá trị âm.',
          formula: 'Phí vận chuyển thu của khách × (±1)',
        },
        {
          stt: '(1.4)',
          term: 'Chiết khấu',
          meaning:
            'Tổng chiết khấu (gồm cả phần thuế) của cả chiết khấu từng item và chiết khấu cấp bill (mã giảm giá). Chiết khấu % được tính trên tổng dòng (giá × SL).',
          formula: 'Chiết khấu = chiết khấu item + chiết khấu bill ',
        },
        {
          stt: '(1)',
          term: 'Doanh thu',
          meaning:
            'Doanh thu thuần từ hoạt động bán hàng. Bao gồm cả thuế VAT và phí giao hàng, sau khi đã trừ chiết khấu.',
          formula: 'Doanh thu = Tiền hàng thực bán + Thuế VAT + Phí giao hàng khách - Chiết khấu',
        },
        {
          stt: '(2.1)',
          term: 'Giá vốn hàng hóa',
          meaning:
            'Tổng giá vốn nhân số lượng của tất cả sản phẩm trong đơn. Đơn trả hàng dùng giá trị âm.',
          formula: 'Giá vốn hàng hóa = Σ (Giá vốn × Số lượng × (±1))',
        },
        {
          stt: '(2.2)',
          term: 'Thanh toán điểm',
          meaning: 'Số tiền khách hàng thanh toán bằng điểm tích lũy (chi phí đối với cửa hàng).',
          formula: 'Thanh toán điểm × (±1)',
        },
        {
          stt: '(2.3)',
          term: 'Phí GH (shop)',
          meaning:
            'Phí giao hàng cửa hàng trả cho đối tác vận chuyển (chi phí đối với cửa hàng). Lấy từ đơn hàng liên kết.',
          formula: 'Phí trả hãng vận chuyển × (±1)',
        },
        {
          stt: '(2)',
          term: 'Tổng chi phí',
          meaning: 'Tổng hợp tất cả các loại chi phí phát sinh trong đơn hàng.',
          formula: 'Tổng chi phí = Giá vốn + Thanh toán điểm + Phí trả hãng vận chuyển',
        },
        {
          stt: '(5)',
          term: 'Lợi nhuận',
          meaning: 'Lợi nhuận sau khi trừ toàn bộ chi phí khỏi doanh thu. Bao gồm cả thuế VAT.',
          formula: 'Lợi nhuận = Doanh thu - Tổng chi phí',
        },
        {
          stt: '(6)',
          term: 'Lợi nhuận gộp',
          meaning:
            'Doanh thu thuần trước thuế, sau khi trừ giá vốn. Chưa trừ phí GH shop và thanh toán điểm.',
          formula: 'Lợi nhuận gộp = Doanh thu - Thuế VAT - Giá vốn hàng hoá',
        },
        {
          stt: '(7)',
          term: 'Lợi nhuận ròng',
          meaning: 'Lợi nhuận cuối cùng sau khi trừ thêm thanh toán điểm và phí giao hàng shop.',
          formula:
            'Lợi nhuận ròng = Lợi nhuận gộp - Thanh toán điểm - Phí vận chuyển thu của khách',
        },
      ],
    }
  },
}
</script>

<style scoped>
.formula-code {
  display: block;
  background: #f4f6fa;
  border-radius: 4px;
  padding: 4px 8px;
  font-size: 0.82rem;
  color: #76767f;
  white-space: pre-wrap;
  word-break: break-word;
}
</style>
